import { render, staticRenderFns } from "./Breadcrumbs.component.vue?vue&type=template&id=5774e4dd&scoped=true&"
import script from "./Breadcrumbs.component.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.component.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrumbs.component.vue?vue&type=style&index=0&id=5774e4dd&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5774e4dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VIcon})
